import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const DevToolsRoutes = defineRoute({
    masquerade: {
        route: {
            path: "/devtools/masquerade",
            component: () => loadView(import("./DevMasquerade.vue")),
        },
    },
    database: {
        route: {
            path: "/devtools/database",
            component: () => loadView(import("./DevDatabase.vue")),
        },
    },
    maintenance: {
        route: {
            path: "/devtools/maintenance",
            component: () => loadView(import("./DevMaintenance.vue")),
        },
    },
    daemon: {
        route: {
            path: "/devtools/daemon",
            component: () => loadView(import("./DevDaemon.vue")),
        },
    },
    mobile: {
        route: {
            path: "/devtools/mobile",
            component: () => loadView(import("./DevMobile.vue")),
        },
    },
});
